import React from "react";
import { AuthorImage, dateFormatter, getTimeStampOptions } from "./utils";
import TimeAgo from "react-timeago";
import { formatter } from "../../../isomorphic/utils";
import PropTypes from "prop-types";
import { ShowReadTime } from "../atoms/read-time/index";
import get from "lodash/get";

export function SingleAuthorTemplate({
  textStory,
  liveBlog,
  listicleStory,
  authorNameKeyword,
  storyPubKeyword,
  author = {},
  date,
  showDateOnly = false,
  config = {},
  hideImage = false,
  readTime
}) {
  const publishKeyword = !showDateOnly ? "Published on : " : "";
  const getTimeStamp =
    textStory === "hero-overlay" ? (
      <TimeAgo
        date={date}
        formatter={(value, unit, suffix, date, defaultFormatter) =>
          formatter(value, unit, suffix, date, defaultFormatter)
        }
        title={null}
      />
    ) : (
      <TimeAgo
        date={date}
        formatter={(value, unit, suffix, date, defaultFormatter) =>
          dateFormatter(value, unit, suffix, date, defaultFormatter)
        }
        title={null}
      />
    );
  const showRelativeTime = get(config, ["theme-attributes", "story-timeformat"])
    ? get(config, ["theme-attributes", "story-timeformat"]) === "relativetime"
    : false;
  const options = getTimeStampOptions(config);
  const timeZone = get(config, ["theme-attributes", "story-timeformat"]);
  const publishedAt = new Date(date).toLocaleString("en-US", options);
  const readTimeCustomClass =
    (textStory || liveBlog || listicleStory) === "hero-overlay" ? "read-time-overlay" : "read-time-default";
  return (
    <div className="author">
      {!hideImage && <AuthorImage {...author} />}
      <div className="author__content">
        <h3 className="author__name" data-author-name="true">
          {authorNameKeyword}
          {author.name}
        </h3>
        <div className="author__date-read-time-wrapper">
          {date && (
            <div className="author__published-date" data-publish-date="true">
              {storyPubKeyword || (publishKeyword && <span className="pub-keyword">{publishKeyword}</span>)}
              {showRelativeTime ? (
                <div className="author__time-stamp-wrapper">{getTimeStamp}</div>
              ) : (
                <div className="author__time-stamp-wrapper">
                  <time dateTime={new Date(date).toISOString()}>
                    {publishedAt} {timeZone !== "relativetime" ? timeZone : ""}
                  </time>
                </div>
              )}
            </div>
          )}
          <ShowReadTime storyReadTime={readTime} customCssClasses={readTimeCustomClass} />
        </div>
      </div>
    </div>
  );
}
SingleAuthorTemplate.propTypes = {
  hideImage: PropTypes.bool,
  config: PropTypes.object,
  showDateOnly: PropTypes.bool,
  author: PropTypes.object,
  authorNameKeyword: PropTypes.func,
  storyPubKeyword: PropTypes.func,
  textStory: PropTypes.string,
  liveBlog: PropTypes.string,
  listicleStory: PropTypes.string,
  date: PropTypes.number,
  readTime: PropTypes.number,
  story: PropTypes.object
};
